import { render } from "./StaffAssessmentTab.vue?vue&type=template&id=00e75632"
import script from "./StaffAssessmentTab.vue?vue&type=script&lang=js"
export * from "./StaffAssessmentTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__